import { LOGO_URL, CONTACT } from "./data";
import { Phone, Mail, MapPin } from "lucide-react";

const NAV = [
  { label: "Home", target: "top" },
  { label: "Leistungen", target: "leistungen" },
  { label: "Branchen", target: "referenzen" },
  { label: "Über uns", target: "manifest" },
  { label: "Kontakt", target: "kontakt" },
];

function scrollTo(id) {
  if (id === "top") return window.scrollTo({ top: 0, behavior: "smooth" });
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

export default function Footer({ onOpenImpressum, onOpenAgb, onOpenDatenschutz }) {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-[#0d0d0f] py-16">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr_1fr] lg:gap-16">
          {/* Brand */}
          <div className="max-w-sm">
            <div className="mb-6 flex items-center gap-3">
              <img src={LOGO_URL} alt="Swiss Precision Cleaning" className="h-10 w-10 object-contain" />
              <div className="flex flex-col leading-none">
                <span className="font-head text-[13px] tracking-[0.32em] text-metal">SWISS PRECISION</span>
                <span className="font-mono-spc text-[9px] tracking-[0.42em] text-[#c0c5ce]/60 mt-1">CLEANING · CH</span>
              </div>
            </div>
            <ul className="space-y-3 text-sm font-light text-[#c0c5ce]/80">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#4fd1c5]" strokeWidth={1.5} />
                <span>
                  {CONTACT.address}
                  <br />
                  {CONTACT.city}, Schweiz
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 shrink-0 text-[#4fd1c5]" strokeWidth={1.5} />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="transition-colors hover:text-[#4fd1c5]">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-[#4fd1c5]" strokeWidth={1.5} />
                <a href={`mailto:${CONTACT.email}`} className="break-all transition-colors hover:text-[#4fd1c5]">
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="mb-5 font-mono-spc text-[10px] uppercase tracking-[0.3em] text-[#8a919e]">Navigation</h4>
            <ul className="space-y-3 text-sm font-light text-[#c0c5ce]/80">
              {NAV.map((n) => (
                <li key={n.label}>
                  <button
                    data-testid={`footer-nav-${n.target}`}
                    onClick={() => scrollTo(n.target)}
                    className="transition-colors duration-300 hover:text-[#4fd1c5]"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h4 className="mb-5 font-mono-spc text-[10px] uppercase tracking-[0.3em] text-[#8a919e]">Rechtliches</h4>
            <ul className="space-y-3 text-sm font-light text-[#c0c5ce]/80">
              <li>
                <button data-testid="footer-impressum" onClick={onOpenImpressum} className="transition-colors duration-300 hover:text-[#4fd1c5]">
                  Impressum
                </button>
              </li>
              <li>
                <button data-testid="footer-datenschutz" onClick={onOpenDatenschutz} className="text-left transition-colors duration-300 hover:text-[#4fd1c5]">
                  Datenschutzerklärung
                </button>
              </li>
              <li>
                <button data-testid="footer-agb" onClick={onOpenAgb} className="text-left transition-colors duration-300 hover:text-[#4fd1c5]">
                  Allgemeine Geschäftsbedingungen (AGB)
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8">
          <p className="font-mono-spc text-[11px] tracking-[0.2em] text-[#8a919e]">
            © {year} EMMAX Dienstleistungs GmbH. Alle Rechte vorbehalten.
          </p>
          <p className="max-w-3xl text-[11px] font-light leading-relaxed text-[#8a919e]/50">
            Swiss Precision Cleaning ist eine Marke der EMMAX Dienstleistungs GmbH. Sämtliche Leistungen werden
            ausschliesslich durch die EMMAX Dienstleistungs GmbH erbracht.
          </p>
        </div>
      </div>
    </footer>
  );
}
